import { value } from '@takeshape/util';
import { branding } from "../../config.js";
import { addAuthenticationFormConfig, addAuthenticationSchema, authenticationFormConfig, updateAuthentication } from "../../util/authentication.js";
import { isCompleteGraphQLConfig } from "../../util/config.js";
import { addHealthCheckFormConfig, addHealthCheckSchema, getHealthCheck, healthCheckFormConfig, updateHealthCheck } from "../../util/health.js";
import { getInitialData } from "../../util/initial-data.js";
const serviceProvider = {
    name: 'graphql',
    title: 'GraphQL',
    description: `Adding a generic GraphQL service connection allows you to add queries and mutations to your ${branding.productName} project that access a remote service.`,
    links: [
        { title: 'Read More', url: 'https://en.wikipedia.org/wiki/GraphQL' },
        { title: 'Homepage', url: 'https://graphql.org/' },
        { title: 'Docs', url: '/docs/services/providers/graphql' }
    ],
    serviceType: 'graphql',
    introspectionType: 'graphql',
    createId: value('graphql'),
    getFormSchema: value(addAuthenticationSchema(addHealthCheckSchema({
        type: 'object',
        properties: {
            id: {
                title: 'Slug',
                type: 'string',
                pattern: '[0-9a-z_-]+'
            },
            title: {
                title: 'Name',
                type: 'string'
            },
            namespace: {
                title: 'Namespace',
                type: 'string',
                pattern: '^[A-Z][A-Za-z]+$'
            },
            endpoint: {
                title: 'Endpoint',
                type: 'string',
                pattern: '^https?:\\/\\/'
            }
        },
        required: ['title', 'id', 'namespace', 'endpoint']
    }, { checkNames: ['graphqlIntrospection', 'ping', 'none'] }))),
    getFormConfig: value(addHealthCheckFormConfig(addAuthenticationFormConfig({
        order: ['title', 'id', 'namespace', 'endpoint'],
        properties: {
            title: {
                widget: 'singleLineText'
            },
            id: {
                widget: 'singleLineText',
                instructions: 'The human-readable unique identifier for this service.'
            },
            namespace: {
                widget: 'singleLineText',
                instructions: 'A pascal-case prefix that will be added to types in your GraphQL API.'
            },
            endpoint: {
                widget: 'singleLineText'
            }
        }
    }))),
    getForms: value({
        ...healthCheckFormConfig,
        ...authenticationFormConfig
    }),
    getInitialData(serviceConfig) {
        const initialData = getInitialData(serviceProvider, serviceConfig);
        if (initialData.isNew) {
            initialData.healthCheck = {
                checkName: 'graphqlIntrospection'
            };
            initialData.authentication = {
                type: 'none'
            };
        }
        return initialData;
    },
    getConfig(formData) {
        const config = {
            title: formData.title ?? 'GraphQL',
            namespace: formData.namespace ?? 'GraphQL',
            provider: 'graphql',
            serviceType: 'graphql',
            authenticationType: 'none'
        };
        if (formData?.endpoint) {
            config.options = {
                endpoint: formData.endpoint
            };
        }
        return updateHealthCheck(updateAuthentication(config, formData), formData);
    },
    isCompleteConfig: isCompleteGraphQLConfig,
    getHealthCheck: getHealthCheck({ checkName: 'graphqlIntrospection' })
};
export default serviceProvider;
